import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import './style.scss';
import errorHandler from '&/utils/errorHandler';

class ErrorBoundary extends Component {
	componentDidCatch(error, errorInfo) {
		errorHandler(error);
	}

	render() {
		if (this.props.error) {
			return (
				<section className='error-boundary'>
					<Helmet>
						<title>Error | {process.env.REACT_APP_TITLE}</title>
					</Helmet>

					<Paper className='paper'>
						<Typography variant='h1'>Error</Typography>
					</Paper>
				</section>
			);
		}

		return this.props.children;
	}
}

const mapStateToProps = state => ({
	error: state.app.error,
});

export default connect(mapStateToProps)(ErrorBoundary);
